var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7213 18.8816L0.173704 2.89503C-0.0223299 2.70448 -0.0577678 2.35117 0.0946715 2.10578L0.647053 1.21738C0.799493 0.971993 1.08243 0.927697 1.27875 1.11859L17.8263 17.1051C18.0223 17.2957 18.0578 17.649 17.9053 17.8944L17.3529 18.7828C17.2005 19.0282 16.9176 19.0721 16.7213 18.8816Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3503 2.19476L2.36378 18.7423C2.17323 18.9383 1.81992 18.9738 1.57453 18.8213L0.686133 18.269C0.440743 18.1165 0.396447 17.8336 0.587344 17.6373L16.5739 1.08972C16.7644 0.893686 17.1177 0.858248 17.3631 1.01069L18.2515 1.56307C18.4969 1.71551 18.5409 1.99845 18.3503 2.19476Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.3e3708d31c8f6403ed69e90ad8483cf0.svg";
export { ForwardRef as ReactComponent };